import { useState } from "react";
import CustomizeComp from "../../Aside2Components/CustomizeComp";
import ExpandableWithToggle from "../../../../../components/BasicComponents/ExpandableWithToggle";

const ContainerWithToggle = (props) => {
  const { ControllerProps, currentSheet, dispatchItemToredux, defaultValue } =
    props;
  const { innerComponents } = ControllerProps;
  return (
    <main className="flex items-start justify-start w-full">
      <ExpandableWithToggle
        ControllerProps={ControllerProps}
        currentSheet={currentSheet}
        dispatchItemToredux={dispatchItemToredux}
        defaultValue={defaultValue}
        componentType="CONTAINER_WITH_TOGGLE"
      >
        {innerComponents.map((Controller, i) => (
          <CustomizeComp
            key={i}
            ControllerProps={Controller}
            parentKey="customization"
            currentSheet={currentSheet}
          />
        ))}
      </ExpandableWithToggle>
    </main>
  );
};
export { ContainerWithToggle };
